import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { LibTableRecordActionComponent } from 'tuain-ng-forms-lib';
import { IconDictionaryService } from 'src/app/services/icon-dictionary.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'row-action',
  templateUrl: './row-action.component.html',
  styleUrls: ['./row-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppTableRecordActionComponent extends LibTableRecordActionComponent {
  icon: String;
  @Input() size = 'default';
  @Input() type = 'default';
  isActive: boolean;

  constructor(public _iconDictionary: IconDictionaryService) {
    super();
  }

  override start() {
    super.start()
    if (this.action?.actionType === 'CHECK' && this.action?.stateField) {
      this.isActive = this.recordData?.[this.action?.stateField] ?? false;
    }
    if (this.action.actionType === 'CHECK') {
      this.icon = this._iconDictionary.mapIcon('SELECTROW');
    } else if (this.action.actionType === 'UNCHECK') {
      this.icon = this._iconDictionary.mapIcon('UNSELECTROW');
    } else {
      this.icon = this._iconDictionary.mapIcon(this.action.iconName);
    }
  }
}
